export default from './module';


// WEBPACK FOOTER //
// ./src/app/authorized/project/pipeline/index.js